/* ============================================================
   Skin Protocol 2.0 — Shopify section behavior
   Plan switch · live pricing from data-attrs · /cart/add.js (real)
   with demo fallback · tabs (science / how-to-take / ingredients)
   · timeline + improvement panel · FAQ · review modal · build-a-bundle
   · sticky add-to-cart · ticker · reveal · gallery swipe.
   Re-initialises on shopify:section:load so it works in the editor.
   ============================================================ */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setText(sel, v, r) { $all(sel, r).forEach(function (el) { el.textContent = v; }); }

  function init(root) {
    root = root || document;
    if (root.__sp2) return; // guard double-init within same node
    root.__sp2 = true;

    // ---------- pricing engine (variants × selling plans) ----------
    var formEl = $('[data-sp-form]', root);
    var pricingEl = $('[data-sp-pricing]', root) || formEl;
    var PRICING = {};
    try { PRICING = JSON.parse((pricingEl && pricingEl.getAttribute('data-sp-pricing')) || '{}'); } catch (e) { PRICING = {}; }
    var variants = PRICING.variants || {};
    var state = { vid: PRICING.initial || Object.keys(variants)[0], mode: 'sub', planId: null, opts: (PRICING.initialOptions || []).slice() };

    function curVariant() { return variants[state.vid]; }
    function curPlan() { var v = curVariant(); if (!v || !v.plans || !v.plans.length) return null; var f = v.plans.filter(function (p) { return String(p.id) === String(state.planId); }); return f[0] || v.plans[0]; }
    function variantByOpts(opts) { for (var id in variants) { var v = variants[id], ok = true; for (var i = 0; i < opts.length; i++) { if (v.opts[i] !== opts[i]) { ok = false; break; } } if (ok) return v; } return null; }
    function activeAmount() { var v = curVariant(); if (!v) return (AN ? Number(AN.getAttribute('data-ev-price') || 0) : 0); var isSub = state.mode === 'sub' && v.plans && v.plans.length; var d = isSub ? (curPlan() || v) : v; return Number(d.amount || 0); }

    function renderPricing() {
      var v = curVariant(); if (!v) return;
      var hasPlans = v.plans && v.plans.length;
      var isSub = state.mode === 'sub' && hasPlans;
      $all('[data-mode]', root).forEach(function (b) { b.classList.toggle('on', b.dataset.mode === (isSub ? 'sub' : 'onetime')); });
      var modesWrap = $('.modes', root); if (modesWrap) modesWrap.style.display = hasPlans ? '' : 'none';
      var freq = $('[data-freq]', root); if (freq) freq.classList.toggle('collapsed', !isSub);
      var cad = $('[data-cadence]', root);
      if (cad) { if (hasPlans) { var cp = curPlan() || {}; cad.innerHTML = v.plans.map(function (p) { return '<button class="freq-pill' + (String(p.id) === String(cp.id) ? ' on' : '') + '" type="button" data-cadence-plan="' + p.id + '">' + (p.label || 'Subscribe') + '</button>'; }).join(''); } else { cad.innerHTML = ''; } }
      var d = isSub ? (curPlan() || v) : v;
      setText('[data-now]', d.now, root);
      $all('[data-was]', root).forEach(function (s) { s.textContent = d.was || ''; s.style.display = d.was ? '' : 'none'; });
      setText('[data-save]', d.save || '', root); setText('[data-off]', d.off || '', root);
      setText('[data-day]', d.day || '', root); setText('[data-inst]', d.inst || '', root);
      var chip = $('.save-chip', root); if (chip) chip.style.display = d.save ? '' : 'none';
      var bar = $('[data-stickybar]', root); if (bar) bar.classList.toggle('is-sub', isSub);
      setText('[data-sb-now]', d.now, root);
      $all('[data-sb-was]', root).forEach(function (s) { s.textContent = d.was || ''; s.style.display = d.was ? '' : 'none'; });
      if (formEl) { var idIn = formEl.querySelector('[name="id"]'); if (idIn) idIn.value = v.id; var sp = formEl.querySelector('[data-selling-plan]'); if (sp) sp.value = isSub ? ((curPlan() || {}).id || '') : ''; }
      $all('[data-sp-add]', root).forEach(function (b) { if (v.available === false) b.setAttribute('disabled', ''); else if (b.hasAttribute('disabled')) b.removeAttribute('disabled'); });
      $all('[data-vpick-value]', root).forEach(function (b) { var i = +b.getAttribute('data-opt-index'); b.classList.toggle('on', state.opts[i] === b.getAttribute('data-value')); });
    }
    function setMode(m) { var v = curVariant(); if (!v) return; if (m === 'sub' && (!v.plans || !v.plans.length)) m = 'onetime'; state.mode = m; if (m === 'sub' && !state.planId) state.planId = (v.plans[0] || {}).id || null; renderPricing(); }
    function setCadence(pid) { state.planId = pid; renderPricing(); }
    function setOption(i, val) { state.opts[i] = val; var v = variantByOpts(state.opts); if (v) { state.vid = v.id; if (state.mode === 'sub' && v.plans && v.plans[0]) state.planId = v.plans[0].id; } renderPricing(); }

    /* ---- cart ---- */
    var cartCount = parseInt((($('[data-cart-ct]', root) || {}).textContent || '0'), 10) || 0;
    function bumpCart(n) { cartCount += (n || 1); $all('[data-cart-ct]', root).forEach(function (c) { c.textContent = cartCount; }); }
    function toast(msg) {
      var t = $('[data-toast]', root); if (!t) return;
      t.textContent = msg; t.classList.add('show');
      clearTimeout(root.__t); root.__t = setTimeout(function () { t.classList.remove('show'); }, 2200);
    }
    function openCartDrawer() {
      var d = document.querySelector('cart-drawer, #CartDrawer, .drawer--cart, [data-cart-drawer]');
      if (d && d.classList) { d.classList.add('active', 'is-open', 'animate'); d.removeAttribute('hidden'); return true; }
      return false;
    }
    // ---- analytics (GA4 / dataLayer / Web Pixel friendly) ----
    var AN = root.querySelector('[data-sp-analytics]');
    function evCurrency() { return AN ? (AN.getAttribute('data-ev-currency') || 'AED') : 'AED'; }
    function evItem(extra) { if (!AN) return {}; var it = { item_id: AN.getAttribute('data-ev-id'), item_name: AN.getAttribute('data-ev-name'), item_brand: AN.getAttribute('data-ev-brand') || undefined, price: Number(AN.getAttribute('data-ev-price') || 0) }; if (extra) { for (var k in extra) it[k] = extra[k]; } return it; }
    function activeAmountUnused() {}
    function track(name, params) { if (!AN) return; window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); var payload = { event: name }; if (params) { for (var k in params) payload[k] = params[k]; } window.dataLayer.push(payload); document.dispatchEvent(new CustomEvent('sp2:' + name, { detail: payload })); if (typeof window.gtag === 'function') { try { window.gtag('event', name, params && params.ecommerce ? params.ecommerce : params); } catch (e) {} } }
    function trackAdd(opts) { var qty = (opts && opts.qty) || 1; var val = (opts && opts.value != null) ? opts.value : activeAmount() * qty; track('add_to_cart', { ecommerce: { currency: evCurrency(), value: val, items: [evItem({ quantity: qty, price: activeAmount() })] } }); }

    function addToCart(opts) {
      var label = (opts && opts.label) || 'Added to cart';
      var btn = opts && opts.btn;
      var form = $('[data-sp-form]', root);
      if (btn) { btn.setAttribute('aria-busy', 'true'); }
      function done() { if (btn) btn.removeAttribute('aria-busy'); }
      if (form && window.fetch) {
        var id = (form.querySelector('[name="id"]') || {}).value;
        if (!id) { done(); return; }
        var body = { items: [{ id: Number(id), quantity: (opts && opts.qty) || 1 }] };
        var spv = form.querySelector('[name="selling_plan"]');
        if (spv && spv.value) body.items[0].selling_plan = Number(spv.value);
        if (opts && opts.items) body.items = opts.items;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var added = (data.items ? data.items.length : 1);
            bumpCart(added); toast(label); trackAdd(opts);
            document.dispatchEvent(new CustomEvent('sp2:added'));
            if (!openCartDrawer()) { /* stay on page; drawerless themes can redirect: window.location='/cart'; */ }
            done();
          })
          .catch(function () { bumpCart(); toast(label); done(); });
      } else {
        // demo / preview fallback
        bumpCart((opts && opts.qty) || 1); toast(label); trackAdd(opts); done();
      }
    }

    /* ---- timeline + improvement panel ---- */
    var TL = [
      { wk: 'Weeks 1–3', sw: 'Week 3', t: 'Foundation sets', p: 'Peptides signal, astaxanthin protects, glutathione clears oxidative load. Skin feels more hydrated by day 10–14.', i: 'Habit confirmed within 2 weeks', m: [['Wrinkle smoothing', 14], ['Firmness & lift', 10], ['Hydration', 30], ['Radiance', 18]] },
      { wk: 'Weeks 4–6', sw: 'Week 6', t: 'Radiance emerges', p: 'Tone starts to even. The dull, flat quality recedes — people ask if you’ve changed your routine.', i: 'Week 5 — subscribers commit', m: [['Wrinkle smoothing', 30], ['Firmness & lift', 22], ['Hydration', 52], ['Radiance', 44]] },
      { wk: 'Weeks 7–10', sw: 'Week 10', t: 'Others notice', p: 'All three mechanisms compound. Firmness, radiance and tone peak; collagen density visibly improves.', i: 'Week 8 — most reviews posted', m: [['Wrinkle smoothing', 46], ['Firmness & lift', 38], ['Hydration', 66], ['Radiance', 60]] },
      { wk: 'Week 12', sw: 'Week 12', t: 'New baseline', p: 'Fine lines measurably reduced, elasticity improved. Each month builds on the last.', i: '90% renew at the 90-day mark', m: [['Wrinkle smoothing', 58], ['Firmness & lift', 52], ['Hydration', 78], ['Radiance', 74]] }
    ];
    function renderImpv(d) {
      setText('[data-impv-wk]', d.sw, root);
      var grid = $('[data-impv-grid]', root); if (!grid || !d.m) return;
      grid.innerHTML = d.m.map(function (x) {
        return '<div class="impv-item"><div class="impv-top"><span class="impv-lab">' + x[0] + '</span><span class="impv-val">+' + x[1] + '%</span></div>' +
          '<div class="impv-track"><span class="impv-fill" style="--p:' + x[1] + '%"></span></div></div>';
      }).join('');
    }
    function setTl(n) {
      var steps = $all('[data-tl-step]', root);
      steps.forEach(function (s, i) { s.classList.toggle('active', i === n); s.classList.toggle('done', i <= n); });
      var fill = $('[data-tl-fill]', root); if (fill) { var w = steps.length > 1 ? (n / (steps.length - 1)) * 100 : 0; fill.style.width = w + '%'; }
      var d = TL[n];
      var st = steps[n];
      if (st && st.getAttribute('data-title')) {
        var m = d ? d.m : [];
        try { if (st.getAttribute('data-metrics')) m = JSON.parse(st.getAttribute('data-metrics')); } catch (e) {}
        d = { wk: st.getAttribute('data-wk') || '', sw: st.getAttribute('data-sw') || '', t: st.getAttribute('data-title') || '', p: st.getAttribute('data-p') || '', i: st.getAttribute('data-insight') || '', m: m };
      }
      if (!d) return;
      setText('[data-tl-ttl]', d.t, root); setText('[data-tl-p]', d.p, root); setText('[data-tl-i]', d.i, root); setText('[data-tl-wk]', d.wk, root);
      renderImpv(d);
    }

    /* ---- generic tab groups (science / how-to-take / ingredients) ---- */
    function setTabs(attr, panelAttr, n) {
      $all('[' + attr + ']', root).forEach(function (t) { var on = t.getAttribute(attr) === String(n); t.classList.toggle('on', on); if (t.getAttribute('role') === 'tab') { t.setAttribute('aria-selected', on ? 'true' : 'false'); t.setAttribute('tabindex', on ? '0' : '-1'); } });
      $all('[' + panelAttr + ']', root).forEach(function (p) { p.classList.toggle('on', p.getAttribute(panelAttr) === String(n)); });
    }

    /* ---- FAQ ---- */
    function toggleFaq(btn) {
      var item = btn.closest('[data-faq-item]');
      var open = item.classList.contains('open');
      $all('[data-faq-item]', root).forEach(function (f) { f.classList.remove('open'); var b = f.querySelector('[data-faq]'); if (b) b.setAttribute('aria-expanded', 'false'); });
      if (!open) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    }

    /* ---- review modal ---- */
    function openReview(card) {
      setText('[data-rv-handle]', card.dataset.handle, root);
      setText('[data-rv-cap]', card.dataset.caption, root);
      setText('[data-rv-views]', card.dataset.views, root);
      var m = $('[data-rv-modal]', root); if (m) { m.classList.add('show'); document.body.style.overflow = 'hidden'; }
    }
    function closeReview() { var m = $('[data-rv-modal]', root); if (m) m.classList.remove('show'); document.body.style.overflow = ''; }

    /* ---- build-a-bundle ---- */
    var BB = $('[data-bb]', root);
    var bbPicks = [], BB_MAX = 4, BB_TIERS = [{ n: 1, off: 0 }, { n: 2, off: .1 }, { n: 3, off: .2 }, { n: 4, off: .3 }];
    var BB_PRODUCTS = [];
    if (BB) {
      try { BB_PRODUCTS = JSON.parse(BB.getAttribute('data-bb-products') || '[]'); } catch (e) { BB_PRODUCTS = []; }
    }
    function fmtMoney(n) { var s = (BB && BB.getAttribute('data-money-format')) || 'AED {{amount}}'; return s.replace('{{amount}}', Math.round(n)); }
    function bbProduct(id) { for (var i = 0; i < BB_PRODUCTS.length; i++) { if (BB_PRODUCTS[i].id === id) return BB_PRODUCTS[i]; } }
    function bbTierFor(c) { var t = BB_TIERS[0]; for (var i = 0; i < BB_TIERS.length; i++) { if (c >= BB_TIERS[i].n) t = BB_TIERS[i]; } return t; }
    var CHECK = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function bbInit() {
      var picker = $('[data-bb-picker]', root);
      if (picker) picker.innerHTML = BB_PRODUCTS.map(function (p) {
        return '<button class="bp" type="button" data-bb-pick="' + p.id + '">' +
          '<span class="bp-ct" data-bb-pickct="' + p.id + '" style="display:none">0</span>' +
          '<span class="bp-vial" style="background:' + p.vial + '"></span>' +
          '<span class="bp-n">' + p.name + '</span><span class="bp-p">' + fmtMoney(p.price) + '</span></button>';
      }).join('');
      var ms = $('[data-bb-ms]', root);
      if (ms) ms.innerHTML = BB_TIERS.map(function (t) {
        var left = ((t.n - 1) / (BB_MAX - 1)) * 100;
        var lbl = t.off ? Math.round(t.off * 100) + '%' : 'Pick';
        return '<div class="milestone" data-ms="' + t.n + '" style="left:' + left + '%"><div class="ms-dot">' + CHECK + '</div><div class="ms-label">' + lbl + '</div></div>';
      }).join('');
      bbUpdate(false);
    }
    function bbUpdate(animate) {
      var count = bbPicks.length, tier = bbTierFor(count);
      var off = count >= 1 ? tier.off : 0;
      var subtotal = bbPicks.reduce(function (s, id) { return s + bbProduct(id).price; }, 0);
      var saved = Math.round(subtotal * off), total = subtotal - saved;
      var pct = Math.min(100, (count / BB_MAX) * 100);
      var fill = $('[data-bb-fill]', root); if (fill) fill.style.width = pct + '%';
      $all('[data-ms]', root).forEach(function (m) {
        var nn = +m.dataset.ms, hit = count >= nn, was = m.classList.contains('hit');
        m.classList.toggle('hit', hit);
        if (hit && !was && animate) { m.classList.add('justhit'); setTimeout(function () { m.classList.remove('justhit'); }, 480); }
      });
      var hint = $('[data-bb-hint]', root);
      if (hint) {
        var next = null; for (var i = 0; i < BB_TIERS.length; i++) { if (BB_TIERS[i].n > count) { next = BB_TIERS[i]; break; } }
        if (count === 0) hint.innerHTML = 'Add a formula to start saving \u2728';
        else if (next) hint.innerHTML = 'Add <b>' + (next.n - count) + ' more</b> to unlock <b>' + Math.round(next.off * 100) + '% off</b>';
        else hint.innerHTML = 'Max savings unlocked \u2014 <b>30% off</b> \uD83C\uDF89';
      }
      var slots = $('[data-bb-slots]', root);
      if (slots) {
        var html = '';
        for (var s = 0; s < BB_MAX; s++) {
          var id = bbPicks[s];
          if (id) { var p = bbProduct(id);
            html += '<div class="slot slot-filled' + (animate && s === count - 1 ? ' pop' : '') + '">' +
              '<button class="slot-x" type="button" data-bb-remove="' + s + '" aria-label="Remove"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>' +
              '<span class="slot-vial" style="background:' + p.vial + '"></span><span class="slot-name">' + p.name + '</span></div>';
          } else {
            html += '<div class="slot slot-empty' + (s === count ? ' next' : '') + '"><span class="plus"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" stroke-linecap="round"/></svg></span></div>';
          }
        }
        slots.innerHTML = html;
      }
      $all('[data-bb-pickct]', root).forEach(function (el) {
        var pid = el.dataset.bbPickct, nn = bbPicks.filter(function (x) { return x === pid; }).length;
        el.style.display = nn > 0 ? 'grid' : 'none'; el.textContent = nn;
      });
      $all('[data-bb-pick]', root).forEach(function (b) { b.disabled = count >= BB_MAX; });
      var oc = $('[data-bb-offchip]', root); if (oc) { oc.textContent = Math.round(off * 100) + '% off'; oc.classList.toggle('zero', off === 0); }
      var list = $('[data-bb-list]', root);
      if (list) {
        if (count === 0) list.innerHTML = '<div class="bsum-empty">Your protocol is empty.<br>Tap a formula to start stacking savings.</div>';
        else list.innerHTML = bbPicks.map(function (id, idx) { var p = bbProduct(id);
          return '<div class="bsum-item"><span class="bi-vial" style="background:' + p.vial + '"></span><span class="bi-n">' + p.name + '</span><span class="bi-p">' + fmtMoney(p.price) + '</span><button class="bi-x" type="button" data-bb-remove="' + idx + '" aria-label="Remove">\u2715</button></div>';
        }).join('');
      }
      var rows = $('[data-bb-rows]', root);
      if (rows) {
        if (count === 0) rows.innerHTML = '';
        else {
          var deliv = total >= 300 ? 'FREE' : fmtMoney(25);
          rows.innerHTML = '<div class="bsum-row"><span>' + count + ' formula' + (count > 1 ? 's' : '') + '</span><span class="tnum">' + fmtMoney(subtotal) + '</span></div>' +
            (off > 0 ? '<div class="bsum-row save"><span>Bundle discount (' + Math.round(off * 100) + '%)</span><span class="tnum">\u2212' + fmtMoney(saved) + '</span></div>' : '') +
            '<div class="bsum-row"><span>Delivery</span><span>' + deliv + '</span></div>' +
            '<div class="bsum-row total"><span class="tl">Total</span><span class="tv tnum">' + fmtMoney(total) + '</span></div>';
        }
      }
      var cta = $('[data-bb-add]', root), ctaTxt = $('[data-bb-cta]', root);
      if (cta) cta.disabled = count === 0;
      if (ctaTxt) ctaTxt.textContent = count === 0 ? 'Add a formula' : 'Add protocol \u2014 ' + fmtMoney(total);
    }
    function bbAddToCart() {
      if (!bbPicks.length) return;
      var items = bbPicks.map(function (id, idx) { var p = bbProduct(id); if (!p || !Number(p.variant)) return null; var it = { id: Number(p.variant), quantity: 1, properties: { '_protocol_slot': String(idx + 1) } }; if (p.sp) it.selling_plan = Number(p.sp); return it; }).filter(Boolean);
      var tier = bbTierFor(bbPicks.length);
      var sub = bbPicks.reduce(function (s, id) { return s + bbProduct(id).price; }, 0);
      var total = sub - Math.round(sub * tier.off);
      addToCart({ label: 'Protocol added \u2014 ' + Math.round(tier.off * 100) + '% off \u2713', btn: $('[data-bb-add]', root), items: items.length ? items : null, qty: bbPicks.length, value: total });
      bbPicks = []; bbUpdate(false);
    }

    /* ---- sticky bar ---- */
    (function () {
      var buy = $('[data-sp-buy]', root), bar = $('[data-stickybar]', root);
      if (buy && bar && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { bar.classList.toggle('show', !en[0].isIntersecting); }, { rootMargin: '0px 0px -55% 0px' }).observe(buy);
      }
    })();

    /* ---- ticker ---- */
    (function () {
      var msgs = $all('[data-announce-msg]', root); if (msgs.length < 2) return;
      var i = 0; msgs[0].classList.add('on');
      setInterval(function () { msgs[i].classList.remove('on'); i = (i + 1) % msgs.length; msgs[i].classList.add('on'); }, 3200);
    })();

    /* ---- reveal ---- */
    (function () {
      var els = $all('.reveal', root);
      if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (e) { io.observe(e); });
    })();

    /* ---- gallery swipe + dots ---- */
    var PICS = [['', 'system flat-lay'], ['pic-green', 'tube shot'], ['pic-terra', 'texture'], ['pic-pink', 'lifestyle']];
    var galIndex = 0;
    function setPic(i) {
      i = (i + PICS.length) % PICS.length; galIndex = i;
      var stage = $('[data-gal-stage]', root);
      if (stage) { stage.classList.remove('pic-green', 'pic-terra', 'pic-pink'); if (PICS[i][0]) stage.classList.add(PICS[i][0]); stage.setAttribute('data-label', PICS[i][1]); }
      var main = $('[data-gal-main]', root); if (main) main.classList.toggle('not-hero', i !== 0);
      $all('[data-gal-dot]', root).forEach(function (d, k) { d.classList.toggle('on', k === i); });
      var imgs = $all('[data-gal-img]', root);
      if (imgs.length) { imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); }); }
    }
    (function () {
      var main = $('[data-gal-main]', root); if (!main) return;
      var sx = null, sy = null, drag = false;
      main.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; drag = true; });
      window.addEventListener('pointerup', function (e) {
        if (!drag) return; drag = false; if (sx == null) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) setPic(galIndex + (dx < 0 ? 1 : -1));
        sx = sy = null;
      });
    })();

    /* ---- delegated clicks ---- */
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-mode]'))) setMode(t.dataset.mode);
      else if (e.target.closest('[data-sb-subtoggle]')) setMode(state.mode === 'sub' ? 'onetime' : 'sub');
      else if ((t = e.target.closest('[data-cadence-plan]'))) setCadence(t.getAttribute('data-cadence-plan'));
      else if ((t = e.target.closest('[data-vpick-value]'))) setOption(+t.getAttribute('data-opt-index'), t.getAttribute('data-value'));
      else if ((t = e.target.closest('[data-cmp-toggle]'))) { var cc = t.closest('[data-cmp]'); var op = cc.classList.toggle('open'); t.setAttribute('aria-expanded', op ? 'true' : 'false'); }
      else if ((t = e.target.closest('[data-bb-pick]'))) { if (bbPicks.length < BB_MAX) { bbPicks.push(t.dataset.bbPick); bbUpdate(true); } }
      else if ((t = e.target.closest('[data-bb-remove]'))) { e.stopPropagation(); bbPicks.splice(+t.dataset.bbRemove, 1); bbUpdate(false); }
      else if (e.target.closest('[data-bb-add]')) bbAddToCart();
      else if ((t = e.target.closest('[data-sp-add]'))) { e.preventDefault(); addToCart({ label: t.getAttribute('data-sp-add') || 'Added to cart', btn: t }); }
      else if (e.target.closest('[data-scroll-buy]')) { e.preventDefault(); var el = $('[data-sp-buy]', root) || $('#pdp', root); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' }); }
      else if ((t = e.target.closest('[data-tl-step]'))) setTl(+t.dataset.tlStep);
      else if ((t = e.target.closest('[data-gal-dot]'))) setPic($all('[data-gal-dot]', root).indexOf(t));
      else if ((t = e.target.closest('[data-sci]'))) setTabs('data-sci', 'data-sci-panel', t.getAttribute('data-sci'));
      else if ((t = e.target.closest('[data-htt]'))) setTabs('data-htt', 'data-htt-panel', t.getAttribute('data-htt'));
      else if ((t = e.target.closest('[data-ing]'))) setTabs('data-ing', 'data-ing-panel', t.getAttribute('data-ing'));
      else if ((t = e.target.closest('[data-mv-tab]'))) setTabs('data-mv-tab', 'data-mv-panel', t.getAttribute('data-mv-tab'));
      else if ((t = e.target.closest('[data-faq]'))) toggleFaq(t);
      else if ((t = e.target.closest('[data-review]'))) openReview(t);
      else if (e.target.closest('[data-rv-close]') || e.target === $('[data-rv-modal]', root)) closeReview();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeReview(); return; }
      var tab = e.target.closest && e.target.closest('[role="tab"]'); if (!tab) return;
      var list = tab.closest('[role="tablist"]'); if (!list) return;
      var tabs = $all('[role="tab"]', list); var i = tabs.indexOf(tab); var nn = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') nn = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') nn = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') nn = 0; else if (e.key === 'End') nn = tabs.length - 1;
      if (nn === null) return; e.preventDefault(); tabs[nn].focus(); tabs[nn].click();
    });

    // boot
    var firstMode = $('[data-mode="sub"]', root) ? 'sub' : ($('[data-mode]', root) ? $('[data-mode]', root).dataset.mode : null);
    if (curVariant()) setMode('sub'); else renderPricing();
    setTl(0);
    setTabs('data-sci', 'data-sci-panel', 1);
    setTabs('data-htt', 'data-htt-panel', 1);
    setTabs('data-ing', 'data-ing-panel', 1);
    setTabs('data-mv-tab', 'data-mv-panel', 1);
    setPic(0);
    bbInit();
    track('view_item', { ecommerce: { currency: evCurrency(), value: activeAmount(), items: [evItem({ price: activeAmount() })] } });
  }

  function boot() {
    $all('[data-sp2-root]').forEach(function (r) { r.__sp2 = false; init(r); });
    if (!document.querySelector('[data-sp2-root]')) init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sp2-root]') || e.target;
    if (r) { r.__sp2 = false; init(r); }
  });
})();
